import React from "react";
import PropTypes from "prop-types";

import { Checkbox, FormControlLabel } from "@mui/material";

const MoR = ({ merchantOfRecord, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={merchantOfRecord}
              onChange={onChange}
              name="merchant_of_record"
          color="primary"
        />
      }
      label="Organization using the Round Approach MoR"
    />
  );
};

MoR.propTypes = {
  merchantOfRecord: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MoR;
